module.exports = __webpack_public_path__ + "static/img/2.8f44ed73.png";